import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";

// Properly import images from assets
import personWorkingImage from "../assets/img/image-7.png";
import laptopDisplayImage from "../assets/img/image-8.png";

const TestimonialsSection = () => {
  return (
    <Box sx={{ bgcolor: "#0f0f15", py: 10, width: "100%" }}>
      <Container maxWidth="xl" >
        <Grid container spacing={4} sx={{flexDirection: {xs: "column", sm: "row"}, justifyContent: "space-around"}}>
          {/* Left Column */}
          <Grid item xs={12} md={6} sx={{width: {xs: "100%", md: "45%"}}}>
            <Box
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h2"
                  sx={{
                    color: "#fefefe",
                    fontFamily: "'Outfit-SemiBold', Helvetica",
                    fontWeight: 600,
                    fontSize: "46px",
                    lineHeight: "51px",
                    mb: 2,
                  }}
                >
                  Expert IT Support
                </Typography>

                <Typography
                  sx={{
                    color: "#848384",
                    fontFamily: "'Inter-Regular', Helvetica",
                    fontSize: "16px",
                    lineHeight: "24.3px",
                    mb: 3,
                  }}
                >
                  Our team of certified technicians provides comprehensive remote IT support for businesses of all sizes. We focus on rapid response times, thorough problem resolution, and proactive maintenance to prevent issues before they occur.
                </Typography>

                {/* <Button
                  variant="contained"
                  sx={{
                    bgcolor: "white",
                    color: "#7e7b7e",
                    borderRadius: "11px",
                    textTransform: "none",
                    fontFamily: "'Inter-Regular', Helvetica",
                    fontSize: "15px",
                    fontWeight: "normal",
                    px: 4,
                    py: 1.5,
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  Contact Us
                </Button> */}
              </Box>

              <Box
                component="img"
                src={personWorkingImage}
                alt="IT professional providing remote support"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  mt: "auto",
                }}
              />
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6} sx={{width: {xs: "100%", md: "49%"}}}>
            <Box
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <Box
                component="img"
                src={laptopDisplayImage}
                alt="Modern IT systems and monitoring"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  mb: 4,
                }}
              />

              <Box sx={{ mt: "auto" }}>
                <Typography
                  variant="h2"
                  sx={{
                    color: "#fdfdfd",
                    fontFamily: "'Outfit-SemiBold', Helvetica",
                    fontWeight: 600,
                    fontSize: "52px",
                    lineHeight: "59px",
                    mb: 2,
                  }}
                >
                  Technology Solutions
                </Typography>

                <Typography
                  sx={{
                    color: "#848484",
                    fontFamily: "'Inter-Regular', Helvetica",
                    fontSize: "15px",
                    lineHeight: "24.5px",
                    mb: 3,
                  }}
                >
                  We deliver custom technology solutions tailored to your business needs. From cloud services and network configuration to cybersecurity implementation and system optimization for peak performance.
                </Typography>

                {/* <Button
                  variant="contained"
                  sx={{
                    bgcolor: "white",
                    color: "#b2b1b1",
                    borderRadius: "13px",
                    textTransform: "none",
                    fontFamily: "'Inter-Regular', Helvetica",
                    fontSize: "16px",
                    fontWeight: "normal",
                    px: 4,
                    py: 1.5,
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  Learn More
                </Button> */}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;